module.exports = __webpack_public_path__ + "static/media/achievement_example.1913a58a.png";